<evc-nav-button [leftIcon]="iconEnums.MagnifyingGlassPlus"
            [type]="buttonTypes.icon"
            [size]="buttonSize.lg"
            [variant]="buttonVariants.round"
            (click)="onZoomPlus()"
            [disabled]="value === max">
</evc-nav-button>

<ngx-slider
    class="ngx-slider"
    [(value)]="value"
    [options]="options"
    (valueChange)="onZoom()">
</ngx-slider>

<evc-nav-button [leftIcon]="iconEnums.MagnifyingGlassMinus"
      [type]="buttonTypes.icon"
      [size]="buttonSize.lg"
      [variant]="buttonVariants.round"
      (click)="onZoomMinus()"
      [disabled]="value === min">
</evc-nav-button>
